import * as stylex from "@stylexjs/stylex";
import { colors } from "@softmax/design-system/tokens.stylex";

export const styles = stylex.create({
  linkStates: {
    transitionProperty: "opacity",
    transitionDuration: "100ms",
    opacity: { default: 1, ":hover": 0.7, ":active": 0.5 },
    outlineColor: colors.inverse,
    outlineOffset: 3,
  },
});
